const doc = [({"en":({"js":({"admin":({"element_feedback":({"enter_a_feedback_question":"Enter a feedback question"})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;